import { render } from "./idr_withdraw.vue?vue&type=template&id=1acde24e&scoped=true"
import script from "./idr_withdraw.vue?vue&type=script&lang=js"
export * from "./idr_withdraw.vue?vue&type=script&lang=js"

import "./idr_withdraw.vue?vue&type=style&index=0&id=1acde24e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acde24e"]])

export default __exports__